<div class="kt-portlet">
	<div class="kt-portlet__head kt-portlet__head__custom">
		<div class="kt-portlet__head-progress">
			<!-- here can place a progress bar-->
			<mat-progress-bar mode="indeterminate" *ngIf="viewLoading"></mat-progress-bar>
		</div>
		<div class="kt-portlet__head-label">
			<h3 class="kt-portlet__head-title"><span *ngIf="data.iconClass"><i style="color:orange" class="{{data.iconClass}}"></i>&nbsp;</span>{{data.title}}</h3>
			<span class="kt-portlet__head-icon kt-hide">
				<i class="la la-gear"></i>
			</span>
		</div>
	</div>
	<div class="kt-form">
		<div class="kt-portlet__body" style="padding-top: 0px; padding-bottom: 0px;">
			<div class="form-group kt-form__group row">
				<div class="col-lg-12" [innerHTML]="viewLoading ? data.waitDesciption : data.description">
				</div>
			</div>
		</div>
		<div class="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit text-right">
			<div class="kt-form__actions kt-form__actions--sm">
				<button *ngIf="data.cancelMessage" mat-raised-button (click)="onCancelClick()">{{data.cancelMessage}}</button>&nbsp;
				<button *ngIf="data.okMessage" mat-raised-button (click)="onOkClick()" color="primary" cdkFocusInitial [disabled]="viewLoading">{{data.okMessage}}</button>
			</div>
		</div>
	</div>
</div>
